import styled from '@emotion/styled';

export const ImportFieldSpacer = styled.div`
  // empirical value
  margin-top: 25px;
`;
